import { render, staticRenderFns } from "./PriceSchemesQSR.vue?vue&type=template&id=56a556d3&scoped=true"
import script from "./PriceSchemesQSR.vue?vue&type=script&lang=js"
export * from "./PriceSchemesQSR.vue?vue&type=script&lang=js"
import style0 from "./PriceSchemesQSR.vue?vue&type=style&index=0&id=56a556d3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a556d3",
  null
  
)

export default component.exports